module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGOw1dX8TwlmGDVg1IBRA4aLAQCi0ZIQZuNvWQAAAABJRU5ErkJggg=="